var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1814",
    "data-name": "Grupo 1814",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.634,
    height: 34.634,
    viewBox: "0 0 34.634 34.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1743",
    "data-name": "Grupo 1743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M34.4,14.948a.231.231,0,0,0,.231-.231V13.1a.231.231,0,0,0-.231-.231H30.159a1.039,1.039,0,0,0-.734.3l-2.872,2.872H20.381L27.825,8.6a.231.231,0,0,0,0-.326L26.357,6.809a.231.231,0,0,0-.326,0l-7.445,7.445V8.082L21.458,5.21a1.039,1.039,0,0,0,.3-.734V.231A.231.231,0,0,0,21.532,0H19.916a.231.231,0,0,0-.231.231V4.045L17.317,6.414,14.949,4.045V.231A.231.231,0,0,0,14.718,0H13.1a.231.231,0,0,0-.231.231V4.476a1.039,1.039,0,0,0,.3.734l2.872,2.872v6.172L8.6,6.809a.231.231,0,0,0-.326,0L6.809,8.277a.231.231,0,0,0,0,.326l7.445,7.445H8.082L5.21,13.176a1.039,1.039,0,0,0-.734-.3H.231A.231.231,0,0,0,0,13.1v1.615a.231.231,0,0,0,.231.231H4.046l2.369,2.369L4.046,19.686H.231A.231.231,0,0,0,0,19.916v1.615a.231.231,0,0,0,.231.231H4.476a1.039,1.039,0,0,0,.734-.3l2.872-2.872h6.172L6.809,26.031a.231.231,0,0,0,0,.326l1.468,1.468a.231.231,0,0,0,.326,0l7.445-7.445v6.172l-2.872,2.872a1.039,1.039,0,0,0-.3.734V34.4a.231.231,0,0,0,.231.231h1.615a.231.231,0,0,0,.231-.231V30.589l2.369-2.369,2.369,2.369V34.4a.231.231,0,0,0,.231.231h1.615a.231.231,0,0,0,.231-.231V30.159a1.038,1.038,0,0,0-.3-.734l-2.872-2.872V20.38l7.608,7.608,1.795-1.795-7.608-7.608h6.172l2.872,2.872a1.038,1.038,0,0,0,.734.3H34.4a.231.231,0,0,0,.231-.231V19.916a.231.231,0,0,0-.231-.231H30.589L28.22,17.317l2.369-2.369ZM17.317,19.06l-1.742-1.742,1.742-1.743,1.742,1.743Z",
    fill: "#a6ff00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.61bdee897c561cdb8b3d87b783adefcd.svg";
export { ForwardRef as ReactComponent };